/* tslint:disable */
/* eslint-disable */
/**
 * esign
 * eSign template authoring and request management service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const EsignFieldKind = {
    Signature: 'signature',
    Initial: 'initial',
    Text: 'text',
    Checkbox: 'checkbox',
    RadioGroup: 'radio_group',
} as const;
export type EsignFieldKind = typeof EsignFieldKind[keyof typeof EsignFieldKind];


export function instanceOfEsignFieldKind(value: any): boolean {
    for (const key in EsignFieldKind) {
        if (Object.prototype.hasOwnProperty.call(EsignFieldKind, key)) {
            if (EsignFieldKind[key as keyof typeof EsignFieldKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EsignFieldKindFromJSON(json: any): EsignFieldKind {
    return EsignFieldKindFromJSONTyped(json, false);
}

export function EsignFieldKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): EsignFieldKind {
    return json as EsignFieldKind;
}

export function EsignFieldKindToJSON(value?: EsignFieldKind | null): any {
    return value as any;
}

export function EsignFieldKindToJSONTyped(value: any, ignoreDiscriminator: boolean): EsignFieldKind {
    return value as EsignFieldKind;
}

